<script>
import axios from "axios";
import template from "./thanks.html";
import "./thanks.css";

const API_BASE = "https://api.synbi-systems.com";
const WEEKDAYS = ["日", "月", "火", "水", "木", "金", "土"];

function pad2(n) { return n < 10 ? "0" + n : "" + n; }
function jst(unixSec) { return new Date((unixSec + 9 * 3600) * 1000); }
function fmtDate(unixSec) {
    const d = jst(unixSec);
    return d.getUTCFullYear() + "/" + pad2(d.getUTCMonth() + 1) + "/" + pad2(d.getUTCDate())
        + "（" + WEEKDAYS[d.getUTCDay()] + "）";
}
function fmtTime(unixSec) {
    const d = jst(unixSec);
    return pad2(d.getUTCHours()) + ":" + pad2(d.getUTCMinutes());
}
function sortAsc(arr) {
    return (Array.isArray(arr) ? arr : []).slice().sort(function (a, b) { return a - b; });
}
function extractMessage(err, fallback) {
    if (err && err.response && err.response.data && err.response.data.message) {
        return err.response.data.message;
    }
    return fallback;
}

export default {
    name: "thanks",
    template,
    data() {
        return {
            token: "",
            state: "loading",
            errorMessage: "",
            submitError: "",
            submitting: false,
            merchantName: "",
            customerName: "",
            customerPhone: "",
            reserveTime: null,
            suggests: [],
            holidayDate: [],
            selected: null,
            customDate: "",
            customTime: ""
        };
    },
    computed: {
        viewClass() {
            if (this.state === "confirmed") return "success";
            if (this.state === "select") return "warning";
            return this.state;
        },
        confirmedDate() { return this.reserveTime ? fmtDate(this.reserveTime) : ""; },
        confirmedTime() { return this.reserveTime ? fmtTime(this.reserveTime) : ""; },
        groupedSuggestions() {
            const groups = [];
            const indexByDate = {};
            (this.suggests || []).forEach(function (ts) {
                const date = fmtDate(ts);
                if (indexByDate[date] === undefined) {
                    indexByDate[date] = groups.length;
                    groups.push({ date: date, times: [] });
                }
                groups[indexByDate[date]].times.push({ ts: ts, time: fmtTime(ts) });
            });
            return groups;
        },
        customTimeOptions() {
            return ["11:00", "12:00", "13:00", "14:00", "17:00", "18:00", "19:00", "20:00"];
        }
    },
    watch: {
        state(newVal) {
            if (newVal !== "select") return;
            this.$nextTick(() => { this.initDatepicker(); });
        }
    },
    methods: {
        fetchDetail() {
            const self = this;
            if (!self.token) {
                self.state = "error";
                self.errorMessage = "予約トークンが指定されていません。";
                return;
            }
            self.state = "loading";
            axios.get(API_BASE + "/temp2/detail/.api", { params: { t: self.token } })
                .then(function (res) {
                    const d = res.data || {};
                    self.merchantName = d.merchantName || "";
                    self.customerName = d.customerName || "";
                    self.customerPhone = d.customerPhone || "";
                    self.reserveTime = d.reserveTime || null;
                    self.suggests = sortAsc(d.suggests);
                    self.holidayDate = Array.isArray(d.holidayDate) ? d.holidayDate.slice() : [];
                    if (self.reserveTime) {
                        self.state = "confirmed";
                    } else {
                        self.selected = self.suggests[0];
                        self.state = "select";
                    }
                })
                .catch(function (err) {
                    self.state = "error";
                    self.errorMessage = extractMessage(err, "予約情報の取得に失敗しました。");
                });
        },
        submit() {
            const self = this;
            if (self.submitting || self.selected === null) return;
            self.submitting = true;
            self.submitError = "";
            const body = new URLSearchParams();
            body.append("t", self.token);
            body.append("reserveTime", String(self.selected));
            axios.post(API_BASE + "/temp2/update/.api", body)
                .then(function () {
                    self.reserveTime = self.selected;
                    self.state = "confirmed";
                    self.submitting = false;
                    try { window.scrollTo({ top: 0, behavior: "smooth" }); } catch (e) {}
                })
                .catch(function (err) {
                    self.submitting = false;
                    const resp = err.response;
                    const data = (resp && resp.data) || {};
                    const msg = extractMessage(err, "予約の確定に失敗しました。");
                    if (resp && resp.status === 400) {
                        self.submitError = msg;
                        if (Array.isArray(data.suggests) && data.suggests.length > 0) {
                            // canReserve() === false: APIが返した代替候補で差し替え
                            self.suggests = sortAsc(data.suggests);
                            self.selected = self.suggests[0];
                        } else {
                            // 「既に予約確定済み」等: 真の状態を取り直す
                            self.fetchDetail();
                        }
                    } else if (resp && resp.status === 404) {
                        self.state = "error";
                        self.errorMessage = msg;
                    } else {
                        self.submitError = msg;
                    }
                });
        },
        submitCustom() {
            if (this.submitting) return;
            this.submitError = "";
            const missing = [];
            if (!this.customDate) missing.push("日付");
            if (!this.customTime) missing.push("時間");
            if (missing.length > 0) {
                this.submitError = missing.join("と") + "を選択してください。";
                return;
            }
            const ymd = this.customDate.split("-").map(Number);
            const hm = this.customTime.split(":").map(Number);
            // 入力された日時をJST(UTC+9)の壁掛け時計とみなしてUNIX秒へ
            const utcMs = Date.UTC(ymd[0], ymd[1] - 1, ymd[2], hm[0] - 9, hm[1], 0);
            this.selected = Math.floor(utcMs / 1000);
            this.submit();
        },
        initDatepicker() {
            if (typeof window.jQuery === "undefined") return;
            const $input = window.jQuery(this.$refs.customDateInput);
            if (!$input.length || $input.hasClass("hasDatepicker")) return;
            const self = this;
            $input.datepicker({
                dateFormat: "yy-mm-dd",
                minDate: 0,
                maxDate: 14,
                beforeShowDay: function (date) {
                    const day = date.getDay(); // 0=日, 1=月
                    if (day === 0 || day === 1) return [false, ""];
                    const ymd = date.getFullYear() + "-" + pad2(date.getMonth() + 1) + "-" + pad2(date.getDate());
                    if (self.holidayDate.indexOf(ymd) !== -1) return [false, "thanks2-datepicker-holiday", "定休日"];
                    return [true, ""];
                },
                onSelect: function (dateText) {
                    self.customDate = dateText;
                }
            });
        }
    },
    mounted() {
        this.token = new URL(window.location.href).searchParams.get("t") || "";
        this.fetchDetail();
    }
};
</script>
